export const defaultInitialValues = {
  helpfulness: 0,
  trainingResults: 0,
  easeOfUse: 0,
  interactivity: 0,
};